import { render, staticRenderFns } from "./DeLayoutContent.vue?vue&type=template&id=11335235&scoped=true&"
import script from "./DeLayoutContent.vue?vue&type=script&lang=js&"
export * from "./DeLayoutContent.vue?vue&type=script&lang=js&"
import style0 from "./DeLayoutContent.vue?vue&type=style&index=0&id=11335235&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11335235",
  null
  
)

export default component.exports